import { examinationURL } from "../../../utils/paths";
import { ApiResponse, AsyncThunkConfig } from "../../../api/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance, { ApiError, isAxiosError } from "../../../api/axiosConfig";
import { dispatchNotification } from "../../../utils/redux";
import { I18n } from "react-redux-i18n";
import { InterviewAPI, InterviewUpdate } from "../../../api/interviewApi";

// Mapowanie camelCase na snake_case dla nazw pól (frontend → backend)
const mapCamelToSnake = (obj: any): any => {
  const fieldMap: Record<string, string> = {
    currentPsychophysicalState: "current_psychophysical_state",
    criticalEvents: "critical_events",
    socialAndFamilySituation: "social_and_family_situation",
    drivingVehicles: "driving_vehicles",
    occupationalMedicine: "occupational_medicine",
    securityAndDetectives: "security_and_detectives",
    licensedActivities: "licensed_activities",
    observation: "observation",
  };

  const mappedObj: any = {};

  for (const [key, value] of Object.entries(obj)) {
    const newKey = fieldMap[key] || key;

    mappedObj[newKey] = value;
  }

  return mappedObj;
};

// Mapowanie snake_case na camelCase dla nazw pól (backend → frontend)
const mapSnakeToCamel = (obj: any): any => {
  const fieldMap: Record<string, string> = {
    // eslint-disable-next-line camelcase
    current_psychophysical_state: "currentPsychophysicalState",
    // eslint-disable-next-line camelcase
    critical_events: "criticalEvents",
    // eslint-disable-next-line camelcase
    social_and_family_situation: "socialAndFamilySituation",
    // eslint-disable-next-line camelcase
    driving_vehicles: "drivingVehicles",
    // eslint-disable-next-line camelcase
    occupational_medicine: "occupationalMedicine",
    // eslint-disable-next-line camelcase
    security_and_detectives: "securityAndDetectives",
    // eslint-disable-next-line camelcase
    licensed_activities: "licensedActivities",
    observation: "observation",
  };

  const mappedObj: any = {};

  for (const [key, value] of Object.entries(obj)) {
    const newKey = fieldMap[key] || key;

    mappedObj[newKey] = value;
  }

  return mappedObj;
};

export const fetchInterview = createAsyncThunk<
  ApiResponse<InterviewAPI>,
  string,
  AsyncThunkConfig
>("documentation/interview/get", async (examinationId, thunkAPI) => {
  try {
    const response = await instance.get<ApiResponse<InterviewAPI>>(
      `${examinationURL}${examinationId}/interview/`
    );

    // Mapuj dane z backend (snake_case) na frontend (camelCase)
    if (response.data.results?.interview) {
      const mappedInterview = mapSnakeToCamel(response.data.results.interview);

      response.data.results.interview = mappedInterview;
    }

    return response.data;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});

export const updateInterview = createAsyncThunk<
  ApiResponse<InterviewAPI>,
  InterviewUpdate,
  AsyncThunkConfig
>("documentation/interview/put", async (data, thunkAPI) => {
  try {
    const mappedData = mapCamelToSnake(data.data);

    // Dodaj wszystkie wymagane pola dla InterviewSchema
    const completeData = {
      // eslint-disable-next-line camelcase
      current_psychophysical_state:
        mappedData.current_psychophysical_state || null,
      // eslint-disable-next-line camelcase
      critical_events: mappedData.critical_events || null,
      // eslint-disable-next-line camelcase
      social_and_family_situation:
        mappedData.social_and_family_situation || null,
      observation: mappedData.observation || null,
      // eslint-disable-next-line camelcase
      driving_vehicles: mappedData.driving_vehicles || null,
      // eslint-disable-next-line camelcase
      occupational_medicine: mappedData.occupational_medicine || null,
      // eslint-disable-next-line camelcase
      security_and_detectives: mappedData.security_and_detectives || null,
      // eslint-disable-next-line camelcase
      licensed_activities: mappedData.licensed_activities || null,
    };

    const response = await instance.patch<ApiResponse<InterviewAPI>>(
      `${examinationURL}${data.examinationId}/interview/`,
      {
        interview: completeData,
      }
    );

    dispatchNotification(
      "success",
      I18n.t("DocumentationManagement.snackbar.save")
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err) && err.response != null) {
      const extractedError = err.response.data as ApiError;

      dispatchNotification("error", extractedError.message);

      return thunkAPI.rejectWithValue(extractedError);
    }

    dispatchNotification("error");
    throw err;
  }
});